import { useNavigate } from 'react-router-dom'
import { GridItem, Box, Heading, Spinner } from '@chakra-ui/react'
import { CircularProgressbar } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import { useEffect, useState } from 'react'
import * as api from '../../../api/contadores';
import './grid-pagina-inicial.scss'

const GridPaginaInicial = () => {
  const [paginaAtual, setPaginaAtual] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [loading, setLoading] = useState<boolean>(false);
  const [quantitativoPendencias, setQuantitativoPendencias] = useState(0);
  const [quantitativoVisualizacoesCidade, setQuantitativoVisualizacoesCidade] = useState(0);
  const [quantitativoAvisoRejeitadas, setQuantitativoAvisoRejeitadas] = useState(0);
  const [quantitativoVisualizacoesNoticia, setQuantitativoVisualizacoesNoticia] = useState(0);
  const [quantitativoVisualizacoesBanner, setQuantitativoVisualizacoesBanner] = useState(0);
  const [quantitativoVisualizacoesEvento, setQuantitativoVisualizacoesEvento] = useState(0);
  const [idUsuario, setIdUsuario] = useState<number | null>(null);

  useEffect(() => {
    const dadosLocalStorage = localStorage.getItem("dadosUsuario");
    if (dadosLocalStorage) {
      try {
        const usuario = JSON.parse(dadosLocalStorage);
        setIdUsuario(usuario.seqUsuario);
      } catch (error) {
        console.error("Erro ao recuperar os dados do usuário:", error);
      }
    }
  }, []);

  useEffect(() => {
    const fetchNecesidadeAtuacao = async () => {
      setLoading(true);
      try {
        const data = await api.obterContadores(Number(idUsuario));
        setQuantitativoPendencias(data.totalPendencias);
        setQuantitativoVisualizacoesBanner(data.totalBanners);
        setQuantitativoVisualizacoesCidade(data.totalCidade);
        setQuantitativoVisualizacoesEvento(data.totalEventos);
        setQuantitativoVisualizacoesNoticia(data.totalNoticias);
        setQuantitativoAvisoRejeitadas(data.totalRejeitadas);
        setTotalPages(data.totalPaginas || 1);
      } catch (error) {
        console.error('Erro ao buscar avisos Necessidade Atuacao:', error);
      } finally {
        setLoading(false);
      }
    };

    if (idUsuario) {
      fetchNecesidadeAtuacao();
    }
  }, [idUsuario, paginaAtual, itemsPerPage]);

  const navigate = useNavigate()
  const data = [
    { title: "Avisos de necessidade de atuação", progress: quantitativoPendencias, route: "visualizacao-necessidade-atuacao" },
    { title: "Aviso de publicações rejeitadas", progress: quantitativoAvisoRejeitadas, route: "aviso-publicacoes-rejeitadas" },
    { title: "Visualizações da cidade inteligente", progress: quantitativoVisualizacoesCidade, route: "" },
    { title: "Visualizações de notícias", progress: quantitativoVisualizacoesNoticia, route: "" },
    { title: "Visualizações de banners", progress: quantitativoVisualizacoesBanner, route: "" },
    { title: "Visualizações de eventos", progress: quantitativoVisualizacoesEvento, route: "" },
  ];

  return (
    <div className='main-container-grid'>
      {data.map((item, index) => (
        <GridItem key={index}>
          <Box
            p="20px"
            bgColor="#fff"
            borderRadius="8px"
            textAlign="center"
            height="210px"
            width="280px"
            boxShadow="0px 2px 3px #e5e5e5"
            transition="transform 0.2s ease, box-shadow 0.2s ease"
            _hover={(item.title === "Avisos de necessidade de atuação" ||
              item.title === "Aviso de publicações rejeitadas") ? {
              transform: 'scale(0.99)',
              boxShadow: '0px 3px 6px rgba(0, 0, 0, 0.2)',
              cursor: 'pointer',
            } : {
              transform: 'scale(0.99)',
              boxShadow: '0px 3px 6px rgba(0, 0, 0, 0.2)',
            }}
            onClick={() => navigate(item.route)}
          >
            <div style={{ width: '110px', height: '110px', margin: '0 auto' }}>
              {loading ? (
                <Spinner size="xl" color="blue.500" />
              ) : (
                <CircularProgressbar value={item.progress} text={`${item.progress}`} />
              )}
            </div>
            <Heading fontSize="16px" mt="10px" color="#333">
              {item.title}
            </Heading>
          </Box>
        </GridItem>
      ))}
    </div>
  )
}

export default GridPaginaInicial;
